import(/* webpackMode: "eager" */ "/app/apps/paz-corporate/app/[locale]/(corporate)/not-found.tsx");
